import React from 'react';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { InnerLayout } from 'components/Layout/InnerLayout/InnerLayout';
import { SideNavigation } from 'components/Navigation/SideNavigation';
import { CheckDetailsWrapper } from 'components/Signup/CheckDetails/CheckDetailsWrapper/CheckDetailsWrapper';
import { StepValidator } from 'components/Signup/StepValidator/StepValidator';
import styles from './checkDetails.module.css';

export const CheckDetailsPage = () => {
  return (
    <BaseLayout
      pageTitle="Check details | Introducer Portal"
      contentPadding={false}
    >
      <SideNavigation />
      <StepValidator>
        <InnerLayout contentClassName={styles.mainContent} hasSidebar>
          <CheckDetailsWrapper />
        </InnerLayout>
      </StepValidator>
    </BaseLayout>
  );
};
